import { supabase } from '@/shared/api/supabase';
import { throwAsSupabaseError } from '@/shared/lib';
import {
	type GasStationAround,
	type OpinetStationDetailResponse,
	ProductCodeMap,
	type RegionPriceResponse,
} from '@/shared/types/opinet.types';

const opinetApi = {
	getStationInfo: async (stationId: string) => {
		const params = new URLSearchParams({ id: stationId });
		const { data, error } =
			await supabase.functions.invoke<OpinetStationDetailResponse>(
				`opinet-station-detail?${params}`,
				{ method: 'GET' },
			);

		if (error) throwAsSupabaseError(error);

		return data;
	},

	getStationsAround: async (
		katecY: number,
		katecX: number,
		type: (typeof ProductCodeMap)[keyof typeof ProductCodeMap],
	): Promise<GasStationAround> => {
		const params = new URLSearchParams({
			x: String(katecX),
			y: String(katecY),
			prodcd: type,
			radius: '5000',
			sort: '2',
		});
		const { data, error } = await supabase.functions.invoke<GasStationAround>(
			`opinet-station-around?${params}`,
			{ method: 'GET' },
		);

		if (error) throwAsSupabaseError(error);

		return data || { RESULT: { OIL: [] } };
	},

	getRegionPrice: async (lat: number, lng: number) => {
		const { data, error } =
			await supabase.functions.invoke<RegionPriceResponse>(
				'opinet-region-price',
				{ body: { lat, lng } },
			);

		if (error) throwAsSupabaseError(error);
		return data;
	},

	searchStations: async (
		query: string,
		lat?: number,
		lng?: number,
		count = 20,
	) => {
		const { data, error } = await supabase.rpc('search_gas_stations', {
			search_text: query,
			user_lat: lat,
			user_lng: lng,
			limit_count: count,
		});

		if (error) throwAsSupabaseError(error);

		return data || [];
	},

	searchCarInfo: async (query: string, count = 20) => {
		const { data, error } = await supabase.rpc('search_car_information', {
			search_text: query,
			limit_count: count,
		});

		if (error) throwAsSupabaseError(error);

		return data || [];
	},
};

export default opinetApi;
